import { useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';

function Reports() {
  const [selectedReport, setSelectedReport] = useState('pl');
  const [dateRange, setDateRange] = useState('30d');

  const reports = [
    { id: 'pl', name: 'P&L Statement' },
    { id: 'marketing', name: 'Marketing Calendar' },
    { id: 'forecast', name: '12-Month Forecast' },
    { id: 'recommendations', name: 'Action Items' }
  ];

  const plData = [
    { category: 'Revenue', value: 500000 },
    { category: 'COGS', value: -300000 },
    { category: 'Marketing', value: -50000 },
    { category: 'Operations', value: -75000 },
    { category: 'Net Profit', value: 75000 }
  ];

  return (
    <div className="p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-gray-900">Reports</h1>
          <div className="flex space-x-4">
            <select
              value={dateRange}
              onChange={(e) => setDateRange(e.target.value)}
              className="rounded-lg border-gray-300"
            >
              <option value="7d">Last 7 days</option>
              <option value="30d">Last 30 days</option>
              <option value="90d">Last 90 days</option>
              <option value="1y">Last year</option>
            </select>
            <button className="px-4 py-2 bg-[#0049ac] text-white rounded-lg hover:bg-[#0049ac]/90">
              Export
            </button>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8">
          {/* Report Navigation */}
          <div className="space-y-2">
            {reports.map((report) => (
              <button
                key={report.id}
                onClick={() => setSelectedReport(report.id)}
                className={`w-full text-left px-4 py-2 rounded-lg ${
                  selectedReport === report.id
                    ? 'bg-[#0049ac] text-white'
                    : 'text-gray-700 hover:bg-gray-50'
                }`}
              >
                {report.name}
              </button>
            ))}
          </div>

          {/* Report Content */}
          <div className="lg:col-span-3 bg-white rounded-lg p-6 shadow-sm">
            {selectedReport === 'pl' && (
              <>
                <h2 className="text-lg font-semibold text-gray-900 mb-6">P&L Statement</h2>
                <div className="h-80 mb-6">
                  <ResponsiveContainer width="100%" height="100%">
                    <BarChart data={plData}>
                      <CartesianGrid strokeDasharray="3 3" />
                      <XAxis dataKey="category" />
                      <YAxis />
                      <Tooltip />
                      <Bar
                        dataKey="value"
                        fill={(entry) => (entry.value >= 0 ? '#4F46E5' : '#DC2626')}
                      />
                    </BarChart>
                  </ResponsiveContainer>
                </div>
                <div className="space-y-4">
                  {plData.map((item) => (
                    <div
                      key={item.category}
                      className="flex justify-between items-center py-2 border-b border-gray-200"
                    >
                      <span className="font-medium">{item.category}</span>
                      <span
                        className={
                          item.value >= 0 ? 'text-green-600' : 'text-red-600'
                        }
                      >
                        ${Math.abs(item.value).toLocaleString()}
                      </span>
                    </div>
                  ))}
                </div>
              </>
            )}

            {selectedReport === 'marketing' && (
              <div className="text-center py-12">
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  Marketing Calendar Report
                </h2>
                <p className="text-gray-500">
                  Select export format to download the marketing calendar report
                </p>
              </div>
            )}

            {selectedReport === 'forecast' && (
              <div className="text-center py-12">
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  12-Month Forecast Report
                </h2>
                <p className="text-gray-500">
                  Select export format to download the forecast report
                </p>
              </div>
            )}

            {selectedReport === 'recommendations' && (
              <div className="text-center py-12">
                <h2 className="text-lg font-semibold text-gray-900 mb-2">
                  Action Items Report
                </h2>
                <p className="text-gray-500">
                  Select export format to download the recommendations report
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Reports;